import { useEffect, useState, type ImgHTMLAttributes } from 'react';
import { BookOpen } from 'lucide-react';

export type ObraCoverImageProps = {
    src: string;
    alt: string;
    className?: string;
    /** Classes do ícone (tamanho/cor). O padrão escala com o container. */
    iconClassName?: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'onError'>;

/**
 * Capa de obra: tenta carregar `src`; em falha ou `src` vazio, mostra fundo com ícone central.
 */
export function ObraCoverImage({
    src,
    alt,
    className = 'h-full w-full object-cover',
    iconClassName,
    ...imgProps
}: ObraCoverImageProps) {
    const [failed, setFailed] = useState(() => !src?.trim());

    useEffect(() => {
        setFailed(!src?.trim());
    }, [src]);

    if (failed) {
        const layoutClass = className.replace(/\bobject-\S+/g, '').trim();
        return (
            <div
                className={`flex items-center justify-center bg-gradient-to-br from-white/[0.08] to-neutral-950/95 ${layoutClass}`}
                role="img"
                aria-label={alt || 'Capa indisponível'}
            >
                <BookOpen
                    className={
                        iconClassName ??
                        'h-[22%] w-[22%] min-h-8 min-w-8 max-h-14 max-w-14 text-white/30'
                    }
                    strokeWidth={1.5}
                    aria-hidden
                />
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            onError={() => setFailed(true)}
            {...imgProps}
        />
    );
}
